import { ReactComponent as IconSvg } from 'approot/shared/icons/icon_audio_off.svg';
import Icon, { IconProps } from './icon';

const IconAudioOff = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconAudioOff;
